import React, { Component } from "react";
import Data from "../App";
import AddUiView from "./AddUiView";

class AddView extends Component {
  constructor(props) {
    super(props);
    console.log("creating AddView");
    this.state = {};
    this.handleClose = this.handleClose.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
  }

  componentDidMount() {
    console.log("componentDidMount AddView");
  }

  componentWillUnmount() {
    this.subscription.unsubscribe();
  }

  handleClick(event) {
    this.add();
  }

  onSave(specTree) {
    console.log(JSON.stringify(specTree));
  }

  add() {
    const nameEntered = this.formApi.getState().values.name;

    if (nameEntered !== "") {
      const data = Data.getInstance();
      data.addUiComp(nameEntered, this.props.parentId);
      this.props.onClose();
    }
  }

  cancel() {
    this.props.onClose();
  }

  handleClose(event) {
    this.cancel();
  }

  handleKeyPress(event) {
    if (event.key === "Enter") {
      this.add();
    } else if (event.key === "Escape") {
      //this.cancel();
    }
  }

  render() {
    return (
      <AddUiView
        onClose={this.handleCloseClick}
        onSave={this.onSave}
        templateType={this.props.templateType}
        templateQuantity="n!"
        vms={this.props.vms}
      />
    );
  }
}
export default AddView;



// WEBPACK FOOTER //
// ./src/components/AddView.js